import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-genesys-email-action-buttons',
  templateUrl: './genesys-email-action-buttons.component.html',
  styleUrls: ['./genesys-email-action-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysEmailActionButtonsComponent {
  @Input() isInteractionDisabled: boolean;
  @Input() conversationId: string;
  @Input() isExpanded: boolean;

  @Output() send = new EventEmitter();
  @Output() openOutgoingHeader = new EventEmitter();
  @Output() attachmentSizeLimitError = new EventEmitter();
  @Output() replyCancel = new EventEmitter();
  @Output() handleConfirmation = new EventEmitter();
  @Output() openWrapUpPanel = new EventEmitter();

  onSend() {
    this.send.emit();
  }
  openOutgoingHeaderPanel() {
    this.openOutgoingHeader.emit();
  }
  onAttachmentSizeLimitError(size: number) {
    this.attachmentSizeLimitError.emit(size);
  }
  onReplyCancel() {
    this.replyCancel.emit();
  }
  onHandleConfirmation() {
    this.handleConfirmation.emit();
  }
  onOpenWrapUpPanel() {
    this.openWrapUpPanel.emit();
  }
}
